<script setup>
  import { computed } from 'vue';  
  import Icon from "@/components/icons/Icon.vue";

  const props = defineProps({
    isTall: {
      type: Boolean,
      default: false
    },
    solunarEvents: {
      type: Object,
      required: true,
    }
  });

  const sunrise = computed(() => props.solunarEvents.sunrise ? props.solunarEvents.sunrise.timeFormatted : '--:--');
  const sunset = computed(() => props.solunarEvents.sunset ? props.solunarEvents.sunset.timeFormatted : '--:--');
  const moonrise = computed(() => props.solunarEvents.moonrise ? props.solunarEvents.moonrise.timeFormatted : '--:--');
  const moonset = computed(() => props.solunarEvents.moonset ? props.solunarEvents.moonset.timeFormatted : '--:--');
  const moonStatus = computed(() => props.solunarEvents.moonStatus ? `${props.solunarEvents.moonStatus.eventName}: ${props.solunarEvents.moonStatus.timeFormatted}` : null);
</script>

<template>
  <div class="jwx-tide-spot__event-group" data-content="solunar" :data-is-tall="props.isTall">
    <div class="jwx-tide-spot__solunar-rise-set-events">
      <p class="jwx-tide-spot__solunar-event jwx-tide-spot__solunar-sunrise">
        <Icon name="sunrise" class="jwx-tide-spot__solunar-event-icon" />
        {{ sunrise }}
      </p>
      <p class="jwx-tide-spot__solunar-event jwx-tide-spot__solunar-sunset">
        <Icon name="sunset" class="jwx-tide-spot__solunar-event-icon" />
        {{ sunset }}
      </p>
      <p class="jwx-tide-spot__solunar-event jwx-tide-spot__solunar-moonrise">
        <Icon name="moonrise" class="jwx-tide-spot__solunar-event-icon" />
        {{ moonrise }}
      </p>
      <p class="jwx-tide-spot__solunar-event jwx-tide-spot__solunar-moonset">
        <Icon name="moonset" class="jwx-tide-spot__solunar-event-icon" />
        {{ moonset }}
      </p>
    </div>
    <p v-if="moonStatus" class="jwx-tide-spot__solunar-event jwx-tide-spot__solunar-moonstatus">
      {{ moonStatus }}
    </p>
  </div>
</template>